import type { Order } from '@talos/kyoko';

export const BulkModifyOrderStatusEnum = {
  Pending: 'Pending',
  Error: 'Error',
  Success: 'Success',
} as const;
export type BulkModifyOrderStatusEnum = (typeof BulkModifyOrderStatusEnum)[keyof typeof BulkModifyOrderStatusEnum];

export interface BulkModifyOrderModel {
  newOrderId: string;
  newEndTime?: Date | string | null;
  status?: BulkModifyOrderStatusEnum;
  error?: string;
  orderData: Order;
}
